import { render, staticRenderFns } from "./complaint.vue?vue&type=template&id=a31f8e30&scoped=true&"
import script from "./complaint.vue?vue&type=script&lang=js&"
export * from "./complaint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31f8e30",
  null
  
)

export default component.exports